import React, { useContext, useEffect, useState } from "react";
import { API } from "../conf";
import { Context } from "../App";
import { Backdrop, Box, Button, Checkbox, CircularProgress, FormControlLabel,  IconButton, MenuItem, Stack, TextField, Typography } from "@mui/material";
import CompteForm from "./compte-form";
import CompteBqForm from "./compte-banque-form";
import { Add, Delete } from "@mui/icons-material";
import { communes } from "../asset/variables";

export default function EgliseForm(props) {
    const {updateConnect} = useContext(Context)
    const user = JSON.parse(sessionStorage.getItem('user'))
    const [load, setload] = useState(true)
    const [havefede, setHave] = useState(true)
    
    const [nom, setNom] = useState(props.eglise?.nom??'')
    const [code_analytique, setCode] = useState(props.eglise?.code_analytique??'')
    const [adresse1, setAdresse1] = useState(props.eglise?.adresse1??'')
    const [adresse2, setAdresse2] = useState(props.eglise?.adresse2??'')
    const [commune, setCommune] = useState(communes.find(cm=>cm.nom===props.eglise?.commune)??'')
    const [compte, setCompte] = useState({libelle: '', num_compte: '', solde: 0})
    const [pc_compte, setPc] = useState({libelle: '', num_compte: '', solde: 0})
    const [dime_compte, setDimecompt] = useState({libelle: '', num_compte: '', solde: 0})
    const [offrande_compte, setOffcompt] = useState({libelle: '', num_compte: '', solde: 0})
    const [compte_banque, setBanques] = useState([{libelle:'', solde:'', num_compte:'', banque: '', num_banque: ''}])
    const [limite_petite_caisse, setLimite] = useState(props.eglise?.limite_petite_caisse??500)
    const [have_banque, setHaveBanque] = useState(props.eglise?.have_banque??false)
    const [can_verse_bqfeam, setCanverse] = useState(props.eglise?.can_verse_bqfeam??false)
    const [isFederation, setFede] = useState(props.eglise?.type==='fédération'??false)
    const [isOffLine, setOffLine] = useState(props.eglise?.isOffLine??false)
    
    const [msg, setMsg] = useState()

    async function handleSubmit(event) {
        event.preventDefault()
        setload(true)
        fetch(API.concat(props.edit?`/eglises/${props.eglise?._id}`:'/eglises/create'), {method:props.edit?'PATCH':'POST', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify(isFederation?
                props.edit?{nom, adresse1, adresse2, commune: commune.nom, zip_code:commune.zip, compte_banque, type: 'fédération'}:{nom, adresse1, adresse2, commune: commune.nom, zip_code:commune.zip, compte, dime_compte, offrande_compte, compte_banque, pc_compte, type: 'fédération', have_banque} :
                props.edit?{nom, code_analytique, adresse1, adresse2, commune: commune.nom, zip_code:commune.zip, compte_banque, limite_petite_caisse, have_banque, can_verse_bqfeam, isOffLine}:{nom, code_analytique, adresse1, adresse2, commune: commune.nom, zip_code:commune.zip, compte, pc_compte, compte_banque, limite_petite_caisse, have_banque, can_verse_bqfeam, isOffLine} 
            )
        }).then(async response=>{ 
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    props.add(json); props.close()
                    setload(false)
                }else {
                    const text = await response.text()
                    setMsg(text)
                    setload(false)
                }
            }
        })
    }

    useEffect(()=>{
        async function get_fede() {
            fetch(API.concat(`/eglises/by/${JSON.stringify({type:'fédération'})}`), {method:'GET', headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }}).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setHave(json.length>0)
                    }
                    setload(false)
                }
            })
        }

        get_fede()
    })

    return(
        <Box component='form' onSubmit={handleSubmit} display='flex' flex={1} flexDirection='column'>
            <Typography variant="h5" align="center" marginBottom='5px'>{props.edit?'Modifier':'Créer'} une église</Typography>
            <Typography align="center" marginBottom='15px' color={'carmine.main'}>{msg}</Typography>
            <Stack direction='column' spacing={2} marginInline='20px'>
                <Stack direction='row' spacing={2} alignItems='center'>
                    <TextField required label="Nom" autoFocus sx={{minWidth:'250px', width:'60%'}}
                    error={/(?:^\s+|\s+$)/.test(nom)} helperText={/(?:^\s+|\s+$)/.test(nom) && "ne doit pas commencer/finir ou ne contenir que des espaces" }
                    value={nom} onChange={(event)=> setNom(event.target.value)} />
                    <TextField label="Code analytique" sx={{minWidth:'200px', width:'40%'}} value={code_analytique} required={!isFederation} onChange={(event)=> setCode(event.target.value.toUpperCase())} />
                </Stack>
                <TextField required fullWidth label="N° et libellé de la voie" autoComplete="address-line1"
                error={/(?:^\s+|\s+$)/.test(adresse1)} helperText={/(?:^\s+|\s+$)/.test(adresse1) && "ne doit pas commencer/finir ou ne contenir que des espaces" }
                sx={{minWidth:'250px'}} value={adresse1} onChange={(event)=> setAdresse1(event.target.value)}/>
                <Stack direction='row' spacing={2} alignItems='center'>
                    <TextField fullWidth label="Complément d'adresse" autoComplete="address-line2"
                    error={/(?:^\s+|\s+$)/.test(adresse2)} helperText={/(?:^\s+|\s+$)/.test(adresse2) && "ne doit pas commencer/finir ou ne contenir que des espaces" }
                    sx={{minWidth:'250px'}} value={adresse2} onChange={(event)=> setAdresse2(event.target.value)}/>
                    <TextField required label="Commune" select sx={{width:'40%', minWidth:'200px'}} value={commune} onChange={(event)=> setCommune(event.target.value)}>
                        {communes.map(item=><MenuItem key={item.nom} value={item}>{item.zip} - {item.nom}</MenuItem>)}
                    </TextField>
                </Stack>
                <Stack direction='row' spacing={2} alignItems='center'>
                    {!isFederation&&<TextField required label="Limite petit-caisse" type="number" sx={{minWidth:'150px'}} inputProps={{min:'0', max:'2000'}}
                    value={limite_petite_caisse} onFocus={()=>{if(limite_petite_caisse===0) setLimite('')} }
                    onChange={e=> {const value=parseInt(e.target.value); if(!isNaN(value)&&value<=2000)setLimite(value)}}/>}
                    <FormControlLabel control={<Checkbox checked={have_banque} onChange={()=>setHaveBanque(old=>{if(old)setBanques([{libelle:'', solde:'', num_compte:'', banque: '', num_banque: ''}]); return !old})} />} label="Possède un compte bancaire" />
                    {/* {!isFederation&&<FormControlLabel control={<Checkbox checked={can_verse_bqfeam} onChange={()=>setCanverse(old=>!old)} />} label="Versement compte bancaire fédération"/>} */}
                </Stack>
                <Stack direction='row' spacing={2} alignItems='center'>
                    {((user?.role==='administrateur'&&!havefede)||user?.role==='super administrateur')&&<FormControlLabel control={<Checkbox checked={isFederation} onChange={()=>setFede(old=>{if(!old){setCanverse(false); setHaveBanque(true); setOffLine(false)}; return !old})} />} label="Fédération" />}
                    {/* {!isFederation&&props.edit&&<FormControlLabel control={<Checkbox checked={isOffLine} onChange={()=>setOffLine(old=>!old)}/>} label="Utilise une version hors ligne de l'application"/>} */}
                </Stack>
                {/* Comptes */}
                {!props.edit&&<><Typography variant="subtitle1">Compte de liaison</Typography>
                <CompteForm compte={compte} setCompte={(value, key)=> setCompte(old=>{old[key]=value; return {...old}})}/>
                {isFederation&&<Stack direction='column' spacing={2}>
                    <Typography variant="subtitle1">Compte Dîme</Typography>
                    <CompteForm compte={dime_compte} setCompte={(value, key)=> setDimecompt(old=>{old[key]=value; return {...old}})}/>
                    <Typography variant="subtitle1">Compte Offrandes</Typography>
                    <CompteForm compte={offrande_compte} setCompte={(value, key)=> setOffcompt(old=>{old[key]=value; return {...old}})}/>
                </Stack>}
                <Stack direction='column' spacing={2}>
                    <Typography variant="subtitle1">Compte {isFederation?'':'Petite'} Caisse</Typography>
                    <CompteForm compte={pc_compte} setCompte={(value, key)=> setPc(old=>{old[key]=value; return {...old}})}/>
                </Stack></>}

                {/* Compte bancaires */}
                {(isFederation||have_banque)&&!props.edit&&<>
                    <Typography variant="subtitle1">Comptes Bancaires</Typography>
                    {compte_banque.map((bq_compte, index)=><Stack key={index} direction='row' spacing={2} alignItems='center'>
                        <CompteBqForm {...{noFocus:true, compte:bq_compte, setBanques, index, setBanque:bq=>setBanques(old=>{old[index].banque=bq; return [...old]}), setNum:num=>setBanques(old=>{old[index].num_compte=num; return [...old]}), setNum_banque:num=>setBanques(old=>{old[index].num_banque=num; return [...old]})}}/>
                        {compte_banque.length>1&&<IconButton onClick={()=>setBanques(old=>old.filter((bq, i)=>i!==index))}><Delete/></IconButton>}
                    </Stack>)}
                    <IconButton sx={{alignSelf:'center', backgroundColor:'grey.main'}} onClick={()=>setBanques(old=> [...old, {libelle:'', solde:'', num_compte:'', banque: '', num_banque: ''}])}><Add/></IconButton>
                </>}
            </Stack>

            <Button variant="contained" type="submit" sx={{marginTop:'20px', borderRadius:0, paddingBlock:1.5}}>Enregistrer</Button>
            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}